import { render } from "./NeuerStandortSection.vue?vue&type=template&id=7e944015"
import script from "./NeuerStandortSection.vue?vue&type=script&lang=js"
export * from "./NeuerStandortSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__